import "./vconsole";

import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import "./index.css";

// SuperApp nav bar uses <title>. A normal/nbsp space is treated as empty by
// some WebViews, which makes them fall back to showing the hostname instead.
// Hangul Filler is visually blank but is still a real, non-whitespace character.
const MINIAPP_TITLE = "\u3164";
document.title = MINIAPP_TITLE;
try {
  Object.defineProperty(document, "title", {
    configurable: true,
    get() {
      return MINIAPP_TITLE;
    },
    set() {},
  });
} catch (_) {
  document.title = MINIAPP_TITLE;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
